//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatTime } from '../helpers.js'

export default {
  name: 'Comment',
  props: {
    comment: {
      type: Object,
      default () {
        return {}
      }
    },
    simple: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    editableUploaded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    commentAuthor: function () {
      return this.comment.fio || this.comment.user
    },
    commentTimeText: function () {
      return this.formatTime(this.comment.time)
    }
  },
  methods: {
    onEdit: function () {
      this.$emit('edit-comment', this.comment)
    },
    onDelete: function () {
      this.$emit('delete-comment', this.comment)
    },
    formatTime: function (unixTime) {
      if (unixTime != null) {
        return formatTime(unixTime)
      } else {
        return 'Нет данных'
      }
    }
  }
}
